import {
  ADD_TO_CART_START,
  ADD_TO_CART_SUCCESS,
  ADD_TO_CART_ERROR,
  BOOKING_SUMMARY_FOR_CART_START,
  BOOKING_SUMMARY_FOR_CART_SUCCESS,
  BOOKING_SUMMARY_FOR_CART_ERROR,
  BOOKING_ITEM_DELETE_START,
  BOOKING_ITEM_DELETE_SUCCESS,
  BOOKING_ITEM_DELETE_ERROR,
  APPLY_COUPON_CODE_START,
  APPLY_COUPON_CODE_SUCCESS,
  APPLY_COUPON_CODE_ERROR,
  PAYMENT_INFORMATION_START,
  PAYMENT_INFORMATION_SUCCESS,
  PAYMENT_INFORMATION_ERROR,
  ORDER_SUCCESS_DETAILS_START,
  ORDER_SUCCESS_DETAILS_SUCCESS,
  ORDER_SUCCESS_DETAILS_ERROR,
  BOOKING_ALL_ITEM_DELETED_START,
  BOOKING_ALL_ITEM_DELETED_SUCCESS,
  BOOKING_ALL_ITEM_DELETED_ERROR,
  COUNTRY_LIST_START,
  COUNTRY_LIST_ERROR,
  COUNTRY_LIST_SUCCESS,
  ON_LOG_OUT_EMPTY_CART
} from "Constant/RentalCustomer";

const initialState = {
  loading: false,
  data: [],
  booking_summary: [],
  deleteData: null,
  coponCode: null,
  paymentInfoData: null,
  orderSuccessDetails: null,
  allBookingItemDelete:null,
  countryList:[]
};

export default function addToReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case ADD_TO_CART_START:
      return {
        ...state,
        loading: true,
      };
    case ADD_TO_CART_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case ADD_TO_CART_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case BOOKING_SUMMARY_FOR_CART_START:
      return {
        ...state,
        booking_summary: [],
        loading: true,
      };
    case BOOKING_SUMMARY_FOR_CART_SUCCESS:
      return {
        ...state,
        booking_summary: action.payload,
        loading: false,
      };
    case BOOKING_SUMMARY_FOR_CART_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case BOOKING_ITEM_DELETE_START:
      return {
        ...state,
        loading: true,
      };
    case BOOKING_ITEM_DELETE_SUCCESS:
      return {
        ...state,
        deleteData: action.payload,
        loading: false,
      };
    case BOOKING_ITEM_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case BOOKING_ALL_ITEM_DELETED_START:
      return {
        ...state,
        loading: true,
      };
    case BOOKING_ALL_ITEM_DELETED_SUCCESS:
      return {
        ...state,
        allBookingItemDelete: action.payload,
        loading: false,
      };
    case BOOKING_ALL_ITEM_DELETED_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case APPLY_COUPON_CODE_START:
      return {
        ...state,
        loading: true,
      };
    case APPLY_COUPON_CODE_SUCCESS:
      return {
        ...state,
        coponCode: action.payload,
        loading: false,
      };
    case APPLY_COUPON_CODE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case PAYMENT_INFORMATION_START:
      return {
        ...state,
        loading: true,
      };
    case PAYMENT_INFORMATION_SUCCESS:
      return {
        ...state,
        paymentInfoData: action.payload,
        loading: false,
      };
    case PAYMENT_INFORMATION_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case ORDER_SUCCESS_DETAILS_START:
      return {
        ...state,
        loading: true,
      };
    case ORDER_SUCCESS_DETAILS_SUCCESS:
      return {
        ...state,
        orderSuccessDetails: action.payload,
        loading: false,
      };
    case ORDER_SUCCESS_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
      case COUNTRY_LIST_START:
        return {
          ...state,
          loading: true,
        };
      case COUNTRY_LIST_SUCCESS:
        return {
          ...state,
          countryList: action.payload,
          loading: false,
        };
      case COUNTRY_LIST_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      case ON_LOG_OUT_EMPTY_CART: 
        return {
          ...state,
          booking_summary: []
        }
    default:
      return state;
  }
}
